/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.3.3 */
import { s as setAssetPath$1 } from "./chunks/runtime.js";
import { g } from "./chunks/runtime.js";
let assetPathChanged = false;
const setAssetPath = (path) => {
  assetPathChanged = true;
  setAssetPath$1(path);
};
export {
  assetPathChanged,
  g as getAssetPath,
  setAssetPath
};
